import React, { useEffect } from 'react';
import logo from './images/1694838574272__1___1_-removebg-preview.png';
import logos_circle from './images/logos-circle.png';
import linked_in_icon from './images/linkedin.svg';
import facebook_icon from './images/github-mark.png';
import instagram_icon from './images/instagram.svg';

function Header() {
    useEffect(() => {
        // Handle sticky header and mobile menu toggle
        const handleScroll = () => {
            const header = document.querySelector('.header--sticky');
            if (header) {
                if (window.scrollY > 100) {
                    header.classList.add('sticky');
                } else {
                    header.classList.remove('sticky');
                }
            }
        };

        const menuBtn = document.getElementById('menuBtn');
        const closeTrigger = document.querySelector('.closeTrigger');
        const closeBtn = document.querySelector('.close-menu-activation');
        const popupMenu = document.querySelector('.popup-mobile-menu');

        const openMenu = () => popupMenu?.classList.add('menu-open');
        const closeMenu = () => popupMenu?.classList.remove('menu-open');

        menuBtn?.addEventListener('click', openMenu);
        closeTrigger?.addEventListener('click', closeMenu);
        closeBtn?.addEventListener('click', closeMenu);

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            menuBtn?.removeEventListener('click', openMenu);
            closeTrigger?.removeEventListener('click', closeMenu);
            closeBtn?.removeEventListener('click', closeMenu);
        };
    }, []);

    return (
        <>
            <header className="rn-header haeder-default black-logo-version header--fixed header--sticky">
                <div className="header-wrapper rn-popup-mobile-menu m--0 row align-items-center">
                    <div className="col-lg-2 col-6">
                        <div className="header-left">
                            <div className="logo">
                                <a href="/">
                                    <img src={logo} alt="logo" width="60px" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-10 col-6">
                        <div className="header-center">
                            <nav id="sideNav" className="mainmenu-nav navbar-example2 d-none d-xl-block onepagenav">
                                <ul className="primary-menu nav nav-pills">
                                    <li className="nav-item current"><a className="nav-link" href="#home">Home</a></li>
                                    <li className="nav-item"><a className="nav-link" href="#features">Features</a></li>
                                    <li className="nav-item"><a className="nav-link" href="#portfolio">Portfolio</a></li>
                                    <li className="nav-item"><a className="nav-link" href="#resume">Resume</a></li>
                                    <li className="nav-item"><a className="nav-link" href="#skills">Skills</a></li>
                                    <li className="nav-item"><a className="nav-link" href="#contacts">Contact</a></li>
                                </ul>
                            </nav>
                            <div className="header-right">
                                <a target="_blank" rel="noopener noreferrer" className="rn-btn" href="https://api.whatsapp.com/send?phone=+917889378278&text=Hello Mukhtar Ahmad Zargar, I have an idea that needs to be converted into business!"><span>Whatsapp</span></a>
                                <div className="hamberger-menu d-block d-xl-none">
                                    <i id="menuBtn" className="feather-menu humberger-menu" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            <div className="popup-mobile-menu">
                <div className="inner">
                    <div className="menu-top">
                        <div className="menu-header">
                            <a className="logo" href="/">
                                <img src={logo} alt="Personal Portfolio" width="60px"/>
                            </a>
                            <div className="close-button">
                                <button className="close-menu-activation close">
                                    <i className="feather-x" />
                                </button>
                            </div>
                        </div>
                        <p className="description">
                            Mukhtar Ahmad Zargar - Full Stack Developer & Technical Lead.
                        </p>
                    </div>
                    <div className="content">
                        <ul className="primary-menu nav nav-pills onepagenav">
                            <li className="nav-item"><a className="nav-link smoth-animation" href="#home">Home</a></li>
                            <li className="nav-item"><a className="nav-link smoth-animation" href="#features">Features</a></li>
                            <li className="nav-item"><a className="nav-link smoth-animation" href="#portfolio">Portfolio</a></li>
                            <li className="nav-item"><a className="nav-link smoth-animation" href="#resume">Resume</a></li>
                            <li className="nav-item"><a className="nav-link smoth-animation" href="#skills">Skills</a></li>
                            <li className="nav-item"><a className="nav-link smoth-animation" href="#contacts">Contact</a></li>
                        </ul>
                        <div className="social-share-style-1 mt--40">
                            <span className="title">find with me</span>
                            <ul className="social-share d-flex liststyle">
                                <li className="instagram">
                                    <a href="https://www.instagram.com/maaan_g/" target="_blank" rel="noopener noreferrer">
                                        <img src={instagram_icon} alt="Instagram" />
                                    </a>
                                </li>
                                <li className="linkedin">
                                    <a href="https://www.linkedin.com/in/mukhtar-ahmad-zargar/" target="_blank" rel="noopener noreferrer">
                                        <img src={linked_in_icon} alt="LinkedIn" />
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Header;
